module.exports = __webpack_public_path__ + "img/invoice_request_en.f763458c.svg";